"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _Presenter = _interopRequireDefault(require("./Presenter"));

var _BriefBlock = _interopRequireDefault(require("../../../../BriefBlock"));

require("../styles/_presenters-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PresentersSection(_ref) {
  var presenters = _ref.presenters,
      onAddNewPresenter = _ref.onAddNewPresenter,
      onUpdatePresenter = _ref.onUpdatePresenter,
      onRemovePresenter = _ref.onRemovePresenter,
      canUpdateVideo = _ref.canUpdateVideo,
      video = _ref.video,
      apolloClient = _ref.apolloClient,
      onBlurField = _ref.onBlurField;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "presenters-section"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading4: true
  }, "Are there any presenters in your project?"), canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    type: "TERTIARY",
    onClick: onAddNewPresenter
  }, "Add Presenter") : null), !presenters.length ? /*#__PURE__*/_react.default.createElement(_BriefBlock.default, null, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    placeholder: true,
    noMargin: true
  }, "There aren't any presenters attached to this project. ".concat(canUpdateVideo ? 'You can add new ones with the \'Add Presenter\' button.' : ''))) : null, presenters.map(function (presenter, index) {
    return /*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
      title: "Presenter ".concat(index + 1),
      key: presenter.presenterId,
      leftAlignedHeader: true,
      headerContent: canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "trash",
        size: 20,
        onClick: onRemovePresenter(index),
        color: "regent",
        hoverColor: "redApple"
      }) : null
    }, /*#__PURE__*/_react.default.createElement(_Presenter.default, {
      presenter: presenter,
      index: index,
      onUpdatePresenter: onUpdatePresenter,
      canUpdateVideo: canUpdateVideo,
      video: video,
      apolloClient: apolloClient,
      onBlurField: onBlurField
    }));
  }));
}

var _default = /*#__PURE__*/(0, _react.memo)(PresentersSection);

exports.default = _default;